import { memo } from 'react';

function AccountsIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="#212B36"
        d="M16 5.59a71.201 71.201 0 00-1.973-.069 93.594 93.594 0 00-4.054 0c-.72.016-1.376.04-1.973.069v16.32a46.412 46.412 0 01-2.5-.185V5.775c-.682.071-1.225.148-1.652.221-.882.152-1.494.833-1.593 1.723C2.13 8.837 2 10.73 2 13.75c0 3.02.13 4.913.255 6.03.099.89.71 1.572 1.593 1.724C5.187 21.734 7.671 22 12 22c4.33 0 6.813-.266 8.152-.496.882-.152 1.494-.833 1.593-1.723.125-1.118.255-3.01.255-6.031 0-3.02-.13-4.913-.255-6.03-.099-.89-.71-1.572-1.593-1.724-.427-.073-.97-.15-1.652-.22v15.949c-.685.071-1.511.136-2.5.185V5.59z"
        opacity="0.32"
      />
      <path
        fill="#212B36"
        d="M10.792 2a2.5 2.5 0 00-2.4 1.8l-.524 1.797a70.401 70.401 0 012.105-.076l.339-1.161a.5.5 0 01.48-.36h2.416a.5.5 0 01.48.36l.339 1.161c.774.017 1.474.043 2.105.076L15.608 3.8a2.5 2.5 0 00-2.4-1.8h-2.416z"
      />
      <path
        fill="#212B36"
        fillRule="evenodd"
        d="M18.5 21.725c-.685.071-1.511.136-2.5.185V5.59a46.51 46.51 0 012.5.185v15.95zM8 5.59v16.32a46.412 46.412 0 01-2.5-.185V5.775A46.51 46.51 0 018 5.59z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default memo(AccountsIcon);
